import { AxiosProgressEvent } from "axios";
import { RcFile } from "antd/es/upload";
import type { UploadRequestOption } from "rc-upload/lib/interface";
import { API } from "@/config/axios";

export interface UploadResponse {
  path: string;
  [key: string]: any;
}

/**
 * Custom upload request using axios with authentication
 * @param options - Upload options from Ant Design Upload component
 */
export const customUploadRequest = async (options: UploadRequestOption) => {
  const { file, onSuccess, onError, onProgress } = options;
  const formData = new FormData();
  formData.append("file", file as RcFile);

  try {
    const response = await API.post<UploadResponse>("/util/post/document", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent: AxiosProgressEvent) => {
        const percent = progressEvent.total
          ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
          : 0;
        if (onProgress) {
          onProgress({ percent });
        }
      },
    });

    // Call onSuccess with the response data
    if (onSuccess) {
      onSuccess(response.data);
    }
  } catch (error) {
    console.error("Upload error:", error);
    const errorMessage = error instanceof Error
      ? error
      : new Error("Upload failed");
    if (onError) {
      onError(errorMessage);
    }
  }
};
